import React from 'react';
import { Form, Formik } from 'formik';

import ModalFormTextarea from '@/components/business/ModalForm/ModalFormTextarea/ModalFormTextarea';
import Button, { ButtonStyleType } from '@/components/common/Button/Button';
import AgModalWindow from '@/components/common/ModalWindow/AgModalWindow';
import { ApproveContractLinesVariables } from '@/graphql/contracts/_generated_/approveContractLines.mutation';
import { Fields, validationSchema } from './validation';
import ActionButtonsWrapper from '@/components/common/ModalWindow/ActionButtonsWrapper/ActionButtonsWrapper';

interface IApproveContractLinesModalProps {
  onSave: (comment: ApproveContractLinesVariables['comment']) => void;
  onClose: () => void;
  status: string;
}

export default function ApproveContractLinesModal({
  onSave,
  onClose,
  status
}: IApproveContractLinesModalProps) {
  return (
    <AgModalWindow
      isOpen={true}
      onClose={onClose}
      title="You are about to mark this Contract/Contract Line as Active"
      contentStyle={{ width: 600 }}
    >
      <Formik<Fields>
        initialValues={{
          comment: '',
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          onSave(values.comment);
        }}
        validateOnMount={true}
      >
        {({
          values,
          errors,
          touched,
          isValid,
          setFieldValue,
          setFieldTouched
        }) => (
          <Form>
            <div className="fz-14">
              The Contract/Contract Line is currently marked as {status}.<br />Please enter a reason below.
            </div>

            <div className="mt-15">
              <ModalFormTextarea
                id="comment"
                requiredIcon={true}
                labelTitle="Comment"
                placeholder="Enter short comments"
                value={values.comment}
                onChange={(event) => {
                  setFieldTouched('comment', true, false);
                  setFieldValue('comment', event.target.value);
                }}
                validationMessage={
                  errors?.comment && touched.comment
                    ? errors.comment
                    : undefined
                }
              />
            </div>

            <ActionButtonsWrapper
              leftButton={(
                <Button
                  buttonStyleType={ButtonStyleType.SECONDARY}
                  onClick={onClose}
                >
                  Cancel
                </Button>
              )}
              rightButton={(
                <Button
                  disabled={!isValid}
                  buttonStyleType={ButtonStyleType.PRIMARY}
                  type="submit"
                >
                  Save
                </Button>
              )}
            />
          </Form>
        )}
      </Formik>
    </AgModalWindow>
  );
}
